import React, { memo, ReactElement, ReactNode } from "react";

import { faLink } from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components/macro";

import { FaIcon } from "components/AgGridButtonIcon/agGridButtonIcon";
import { LinkButton } from "components/Form";
import { Row } from "components/Layout";

import { LabelText, Required } from "./layout";
import { Tooltip } from "./Tooltip";

const StyledFaIcon = styled(FaIcon)`
  font-size: 16px;
`;

const StyledToolTipWrapper = styled.div`
  padding-left: 5px;
`;

export interface InlineButton {
  label: string;
  onClick: () => void;
}

interface LabelProps {
  children: string | ReactElement | ReactNode;
  htmlFor?: string;
  error?: string | boolean;
  required?: boolean;
  tooltip?: string;
  altTooltip?: string | object;
  altColor?: string;
  justifyStart?: boolean;
  inlineButton?: InlineButton;
}

export const LabelComponent = (props: LabelProps) => {
  const {
    children,
    htmlFor,
    error,
    required,
    tooltip,
    altTooltip,
    altColor,
    justifyStart,
    inlineButton = null,
  } = props;
  return (
    <Row
      justifyBetween={!justifyStart}
      justifyStart={justifyStart}
      whiteSpaceNoWrap
    >
      <LabelText error={error} htmlFor={htmlFor}>
        {children}
        {required ? <Required /> : ""}
      </LabelText>
      <StyledToolTipWrapper>
        {tooltip && <Tooltip title={tooltip} />}{" "}
        {altTooltip && (
          <Tooltip clickable title={altTooltip}>
            <StyledFaIcon icon={faLink} color={altColor} />
          </Tooltip>
        )}
      </StyledToolTipWrapper>
      {inlineButton && (
        <LinkButton type="button" onClick={inlineButton.onClick}>
          {inlineButton.label}
        </LinkButton>
      )}
    </Row>
  );
};

export const Label = memo(LabelComponent);
